<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="$router.back()" />
      </template>
      パスワード再設定
    </Header>
    <div class="my-5 mx-4">
      <CustomValidationObserver
        v-slot="{ handleSubmit }"
        tag="div"
        class="w-100"
      >
        <BForm @submit.stop.prevent="handleSubmit(nextStep)">
          <p class="mb-4 text-weight-500 text-center text-weight-600">
            入力した電話番号宛(SMS)に、<br />
            再設定用の認証コードが送信されます
          </p>

          <ValidationField
            v-slot="validationState"
            label="携帯電話番号"
            rules="required|numeric|length:11"
            name="phoneNumber"
          >
            <PhoneNumberInputGroup
              v-model="phoneNumber"
              :validation-state="validationState"
              class="mb-4"
            />
          </ValidationField>

          <AppButton block rounded @click="handleSubmit(nextStep)">
            認証コードを送信する
          </AppButton>
        </BForm>
      </CustomValidationObserver>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import PhoneNumberInputGroup from "@/components/molecules/form/PhoneNumberInputGroup.vue";
import { authService } from "@/app/services/AuthService";
import { authStore } from "@/store/auth";

@Component({
  components: {
    AppButton,
    FeatherIcon,
    Header,
    PhoneNumberInputGroup
  }
})
export default class ResetPasswordBeforeLogin extends Vue {
  phoneNumber = "";

  async nextStep() {
    try {
      if (await this.isRegisteredPhoneNumber()) {
        await authStore.changePhoneNumber(this.phoneNumber);
        await this.$router.push({ name: "ResetPasswordAccountAuth" });
      } else {
        await this.$bvModal.msgBoxOk("未登録の電話番号です", {
          centered: true
        });
      }
    } catch {
      await this.$bvModal.msgBoxOk("不正な操作です", {
        centered: true
      });
    }
  }

  async isRegisteredPhoneNumber() {
    const body = {
      phoneNumber: this.phoneNumber
    };
    const res = await authService.requestWorkerLoginStatus(body);
    return res.isActive && res.status !== "new_user";
  }
}
</script>

<style scoped></style>
